/**
 * Initials + deterministic background color for avatars when no photo URL exists.
 */

/** Saturated backgrounds that keep white initials readable (WCAG-friendly enough at small sizes). */
const AVATAR_BG_PALETTE = [
  '#2563eb',
  '#7c3aed',
  '#db2777',
  '#dc2626',
  '#c2410c',
  '#ca8a04',
  '#16a34a',
  '#0d9488',
  '#0891b2',
  '#4f46e5',
  '#9333ea',
  '#be185d',
];

/**
 * @param {string} name - e.g. "Anil Kumar" → "AK"; "Anil" → "AN"
 * @returns {string} 1–2 uppercase letters or "?"
 */
export function getInitialsFromDisplayName(name) {
  const trimmed = String(name ?? '').trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) {
    const w = parts[0].replace(/[^a-zA-Z0-9]/g, '');
    if (!w) return '?';
    if (w.length === 1) return w[0].toUpperCase();
    return (w[0] + w[1]).toUpperCase();
  }
  const first = parts[0][0] || '';
  const last = parts[parts.length - 1][0] || '';
  const a = first.toUpperCase();
  const b = last.toUpperCase();
  if (a && b) return `${a}${b}`;
  if (a) return a;
  if (b) return b;
  return '?';
}

/**
 * Stable “random” color from a string (same seed → same color).
 * @param {string} seed
 * @returns {string} hex color
 */
export function getAvatarColorForSeed(seed) {
  const s = String(seed ?? 'user');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = s.charCodeAt(i) + ((h << 5) - h);
  }
  const idx = Math.abs(h) % AVATAR_BG_PALETTE.length;
  return AVATAR_BG_PALETTE[idx];
}
